import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, concatMap, tap } from 'rxjs/operators';
import { UtilsService } from 'src/app/_services/utils.service';
import { environment } from 'src/environments/environment';
import { AlertApiDialog } from '../alert-api-error/alert-api-dialog';
import { AlertDialog } from '../alert-dialog/alert-dialog';

export interface StartMachineDialogData {
  machineId: any;
  serialNumber: any;
}

@Component({
  selector: 'app-start-machine-dialog',
  templateUrl: './start-machine-dialog.html',
  styleUrls: ['./start-machine-dialog.scss'],
})
export class StartMachineDialog implements OnInit {
  ngModelOptions: any = {
    standalone: true,
  };
  confirmButtonColor: string = 'warn';
  dataSource: any[] = [];
  value: any = null;
  remark: any = null;
  machineId: any = null;
  serialNumber: any = null;
  loading: HTMLIonLoadingElement | null = null;
  saveDisabledButton: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<StartMachineDialog>,
    @Inject(MAT_DIALOG_DATA) public data: StartMachineDialogData,
    private httpClient: HttpClient,
    private router: Router,
    private utilsService: UtilsService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    // if (this.data.confirmButtonColor) {
    //   this.confirmButtonColor = this.data.confirmButtonColor;
    // }

    if (this.data.machineId) {
      this.machineId = this.data.machineId;
    }
    if (this.data.serialNumber) {
      this.serialNumber = this.data.serialNumber;
    }
  }
  startMachine(): void {
    if (this.value == null) {
      this.dialogRef.close();
      this.utilsService.showError('Please enter token value').then((res) => {});
      return;
    }
    this.saveDisabledButton = true;
    this.httpClient
      .post<any>(
        `${environment.baseApiUrl}/support/startMachine`,
        {
          machineId: this.machineId,
          value: this.value,
          remark: this.remark,
        },
        {
          headers: {
            Version: '2',
          },
        }
      )
      .pipe(
        concatMap((res) => {
          if (!res.success) {
            //this.errorFlag = true;
            //return this.utilsService.showAlert(res.message, res.errors);
            this.dialogRef.close();
            return this.openAlertApiDialog(res.message, res?.errors);
          }
          this.dialogRef.close();
          return this.utilsService.showToast('Machine started');
        }),
        catchError((err) => {
          //this.errorFlag = true;
          const defaultMessage =
            'Unable to start machine. Maybe connectivity issue?';

          const message =
            err instanceof HttpErrorResponse
              ? defaultMessage
              : typeof err === 'object'
              ? err.message
              : err ?? defaultMessage;

          // return this.utilsService.showAlert(message);
          this.dialogRef.close();
          return this.openAlertDialog(message);
        })
      )
      .subscribe();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  openAlertDialog(message: string): Observable<boolean> {
    const dialogRef = this.dialog.open(AlertDialog, {
      disableClose: false,
      data: {
        message: message,
      },
    });

    return dialogRef.afterClosed();
  }

  openAlertApiDialog(message: string, errors: any[]): Observable<boolean> {
    const dialogRef = this.dialog.open(AlertApiDialog, {
      disableClose: false,
      data: {
        message: message,
        errors: errors.map((v) => v.message).join('\n'),
      },
    });

    return dialogRef.afterClosed();
  }
}
